module.exports = __webpack_public_path__ + "img/1114718877.ce5323ab.jpg";